<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="报价单">
      <template v-if="hasPermission('销售-报价单-新增')">
        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          @click="newlyAdded"
          >新增报价单</el-button
        >
      </template>
    </pageTitle>
    <basicList
      :config="basicListconfig"
      @sortChange="sortChange"
      @search="searchEvent"
    >
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <template>
            <div class="button button_modify" @click="generateInquiry(row.row)">
              <i class="iconfont icon-dayin"></i> 打印
            </div>
          </template>

          <template v-if="hasPermission('销售-报价单-编辑')">
            <div class="button button_modify" @click="editButton(row.row)">
              <i class="iconfont icon-bianji"></i> 编辑
            </div>
          </template>

          <template v-if="hasPermission('销售-报价单-删除')">
            <div class="button button_modify" @click="deleteRows(row.row)">
              <i class="iconfont icon-shanchu"></i> 删除
            </div>
          </template>
        </div>
      </template>
    </basicList>
    <formWindow
      v-if="dialogParams.visible"
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
    <quotationSheet
      :dialogParams="inquirySheetParams"
      @close="closegenerateInquiry"
    ></quotationSheet>
  </div>
</template>

  <script>
import { mapGetters } from "vuex";
import { quotationGetList, quotationDel } from "@/api/quotation";
import {
  getshoplist,
  customerGetList,
  userPermissionShopGetList,
} from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "quotationManagement",
  components: {
    formWindow: () => import("./formWindow.vue"),
    quotationSheet: () => import("./quotationSheet.vue"),
  },
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      shopIds: [], // 权限管理中允许用户使用的店铺，高级角色看所有店铺

      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      inquirySheetParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        operationWidth: 300,
        search: [
          {
            label: "门店",
            type: "select",
            options: [],
            key: "shop_id",
            value: "",
          },
          {
            label: "客户",
            type: "select",
            options: [],
            key: "customer_id",
          },
          {
            label: "关键字",
            type: "input",
            key: "keyword",
          },
          {
            label: "日期",
            type: "daterange",
            key: "create_time",
          },
        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            sortable: true,
            width: 100,
          },
          {
            label: "门店",
            prop: "shop_name",
            width: 100,
          },

          {
            label: "顾客",
            prop: "customer_name",
            width: 100,
          },
          {
            label: "数量",
            prop: "num",
            sortable: true,
            width: 80,
          },
          {
            label: "报价金额",
            prop: "total_price",
            width: 150,
            isMoney: true,
            sortable: true,
          },
          {
            label: "报价时间",
            prop: "create_time",
            sortable: true,
            width: 200,
          },
          {
            label: "开票",
            prop: "is_invoice",
            filter: "invoiceStatus",
          },
          {
            label: "配送",
            prop: "trans_type",
            filter: "transType",
          },
          {
            label: "制单人",
            prop: "user_name",
          },
          {
            label: "报价单号",
            prop: "form_sn",
            width: 250,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;

    // 初始化列表内容
    this.obtainDataSource().then(() => {
      if (this.roleId == 4) {
        this.basicListconfig.searchParameters.shop_id =
          this.$store.getters.userInfo.shopId;
      }
      this.getlist(); // 先拿基础数据，在拉记录
    });
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
  },
  methods: {
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    // 打印方法
    generateInquiry(row) {
      this.inquirySheetParams.key = new Date().getTime();
      this.inquirySheetParams.visible = true;
      this.inquirySheetParams.id = row.id;
      this.inquirySheetParams.code = row.form_sn;
      this.inquirySheetParams.customerId = row.customer_id;
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该报价单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        quotationDel({
          comp_id: this.compId,
          id: row.id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    // 关闭弹窗
    closegenerateInquiry() {
      this.inquirySheetParams.visible = false;
      this.inquirySheetParams.key = new Date().getTime();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key])) {
            if (data[key].length == 0) {
              delete this.basicListconfig.searchParameters.begin_time;
              delete this.basicListconfig.searchParameters.end_time;
            } else {
              this.basicListconfig.searchParameters.begin_time = data[key][0];
              this.basicListconfig.searchParameters.end_time = data[key][1];
            }
          }
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;

      // 有用户门店权限的，查看只能看指定门店记录
      // 用户选中店铺时，按所选店铺查看; 未选时，按用户权限所有店面查询
      if (!this.basicListconfig.searchParameters["shop_id"]) {
        if (this.shopIds.length != 0) {
          this.basicListconfig.searchParameters["shop_id"] =
            this.shopIds.join(", ");
        }
      }
      this.basicListconfig.searchParameters.comp_id = this.compId;
      this.basicListconfig.searchParameters.user_id = this.userId;

      // 获取报价单列表
      quotationGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },

    // 获取顾客列表
    getCustomers() {
      return customerGetList({
        limit: 10000,
        status: 0,
        comp_id: JSON.parse(getRoles()).comp_id,
      }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "customer_id") {
              item.options = res.data.map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                };
              });
            }
          });
        } else {
          this.$message.error(res.data.msg || "获取供顾客数据源失败！");
        }
      });
    },

    getShops() {
      if (this.roleId == 4) {
        return userPermissionShopGetList({
          comp_id: this.compId,
          user_id: this.userId,
          permission_id: this.getPermissionId("销售-报价单-查看"),
        }).then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: Number(item.id),
                  };
                });
                item.value = JSON.parse(getRoles()).shop_id;
              }
            });
          } else {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });

        // 高级别所看门店不受控制
      } else {
        return getshoplist({
          limit: 10000,
          status: 0,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: Number(item.id),
                  };
                });
              }
            });
          } else {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });
      }
    },

    // 获取基础数据，获取完后才能拿列表
    obtainDataSource() {
      return Promise.all([this.getShops(), this.getCustomers()]);
    },
  },
};
</script>

  <style>
</style>



// WEBPACK FOOTER //
// src/views/quotationManagement/index.vue